export default "__VITE_ASSET__ab25b8f6__"